import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const sorted = [...allComics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              <a href="#latest">最新更新</a>
            </h2>
            <p className="text-foreground-500 text-sm">追更不停歇，最新章节抢先看</p>
          </div>
          <Link
            to="/category/hanman"
            className="text-primary-500 hover:text-primary-600 text-sm font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {sorted.slice(0, 10).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-200 cursor-pointer border border-background-200/70 group"
            >
              <div className="w-16 h-20 md:w-20 md:h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 布丁漫画最新章节`}
                  title={`${comic.title} - 布丁漫画下拉式免费阅读最新章节`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-foreground-900 font-medium text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mt-1 line-clamp-2 hidden sm:block">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center gap-2 flex-wrap">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                      >
                        {tag}
                      </span>
                    ))}
                    <span className="text-xs text-foreground-400">
                      更新至 {comic.chapters.length} 话
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">
                    {comic.updateDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}